import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi2";
import {
  AiOutlineFileText,
  AiOutlinePieChart,
  AiOutlineProduct,
} from "react-icons/ai";
import { FiPackage } from "react-icons/fi";
import { BsBoxSeam } from "react-icons/bs";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { CiUser } from "react-icons/ci";
import { FaRegUser } from "react-icons/fa";
import { TiUser } from "react-icons/ti";
import { FiUser } from "react-icons/fi";
import { MdLibraryAdd, MdNotes } from "react-icons/md";

const DriftLayout = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const loginType = localStorage.getItem("role");
  // console.log("loginType", loginType);

  // Safely get user from localStorage
  const getUser = () => {
    try {
      const userData = localStorage.getItem("user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  };

  const user = getUser();

  // console.log("**********************************", user);

  const handleLogout = () => {
    localStorage.clear();
    if (loginType === "admin" || loginType === "user") {
      window.location.href = "/login"; // Full reload for admin
    } else {
      window.location.href = "/customer/login"; // Full reload for customer
    }
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`;
        }
      }
    };

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };

    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link",
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    openActiveDropdown();

    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  const sidebarControl = () => {
    setSidebarActive(!sidebarActive);
  };

  const mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <>
      {loginType === "admin" || loginType === "user" ? (
        <section className={mobileMenu ? "overlay active" : "overlay"}>
          {/* Sidebar */}
          <aside
            className={
              sidebarActive
                ? "sidebar active"
                : mobileMenu
                  ? "sidebar sidebar-open"
                  : "sidebar"
            }
          >
            <button
              onClick={mobileMenuControl}
              type="button"
              className="sidebar-close-btn"
            >
              <Icon icon="radix-icons:cross-2" />
            </button>
            <div>
              <Link to="/" className="sidebar-logo">
                <img
                  src="/driftAssets/black_color_Logo.png"
                  alt="site logo"
                  className="light-logo"
                />
                <img
                  src="/driftAssets/driftsurfacestudio.png"
                  alt="site logo"
                  className="dark-logo"
                />
                <img
                  src="/driftAssets/black_color_Logo.png"
                  alt="site logo"
                  className="logo-icon"
                />
              </Link>
            </div>
            <div className="sidebar-menu-area">
              <ul className="sidebar-menu" id="sidebar-menu">
                <li>
                  <Link to="/">
                    <Icon
                      icon="solar:home-smile-angle-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </Link>
                  {/* <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                        Home
                      </NavLink>
                    </li>
                  </ul> */}
                </li>
                {user?.department === "admin" && (
                  <li className="dropdown">
                    <Link to="#">
                      <FaRegUser className="me-1" size={15} />
                      <span className="">User</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/user-table"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          User
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Order Management */}
                {user?.order_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <AiOutlineProduct className="me-1" size={20} />
                      <span>Order</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/ordermanagement/neworder"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Customer Order
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/order"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Orders
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/delivery-slip"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Delivery slip
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/ordermanagement/items"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Items
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/rackmanagement/orderstatus"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Order Status
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/dispatch-order"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Dispatch
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/cancelled-order"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Cancelled
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/deleted-order"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Deleted
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {user?.order_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <MdLibraryAdd className="me-1" size={20} />
                      <span> Rack </span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/lanes/canvas"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                           Row Management 
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/rackmanagement/shed"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Shed
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/rackmanagement/process"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Process
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {user?.queue_management_view === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <MdLibraryAdd className="me-1" size={20} />
                      <span> Queue</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/ordermanagement/queue-management-table"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Queue Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/ordermanagement/queue-table"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Queue
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {user?.production_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <AiOutlineProduct className="me-1" size={20} />
                      <span>Production</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {user?.pshade === 1 && (
                        <li>
                          <NavLink
                            to="/productionmanagement/shade"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Shade
                          </NavLink>
                        </li>
                      )}

                      {user?.pbatch === 1 && (
                        <li>
                          <NavLink
                            to="/productionmanagement/BatchCalculator"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Batch
                          </NavLink>
                        </li>
                      )}
                      {user?.pmachine === 1 && (
                        <li>
                          <NavLink
                            to="/productionmanagement/machine"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Machine
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

                {/* Inventory Management */}
                {user?.inventory_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <FiPackage className="me-1" size={20} />
                      <span>Inventory</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/inventorymanagement/invetory"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Inventory Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/inventory/molds-management"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Molds Management
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Customer Management */}
                {user?.customer_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <HiOutlineUsers className="me-1" size={20} />
                      <span>Customer</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      <li>
                        <NavLink
                          to="/customer-management"
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                          Customer
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Product Management */}
                {user?.product_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <AiOutlineProduct className="me-1" size={20} />
                      <span>Products</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {user?.product_management === 1 && (
                        <li>
                          <NavLink
                            to="/products/color"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Color
                          </NavLink>
                        </li>
                      )}
                      {user?.product_management === 1 && (
                        <li>
                          <NavLink
                            to="/products/series"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Series
                          </NavLink>
                        </li>
                      )}
                      {user?.product_management === 1 && (
                        <li>
                          <NavLink
                            to="/products/designe"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Design
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {/* Product Management */}
                {user?.report_view === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <AiOutlineFileText className="me-1" size={20} />
                      <span>Report</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {user?.report_view === 1 && (
                        <li>
                          <NavLink
                            to="/reports"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Order Report
                          </NavLink>
                        </li>
                      )}
                      {user?.item_report === 1 && (
                        <li>
                          <NavLink
                            to="/item-reports"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Inventory Report
                          </NavLink>
                        </li>
                      )}
                      {user?.mold_report === 1 && (
                        <li>
                          <NavLink
                            to="/mold-reports"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Mold Report
                          </NavLink>
                        </li>
                      )}
                      {user?.production_report === 1 && (
                        <li>
                          <NavLink
                            to="/ProductionReportPage"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Production Report
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

                {user?.note_management === 1 && (
                  <li className="dropdown">
                    <Link to="#">
                      <MdNotes className="me-1" size={20} />
                      <span>Notes</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {user?.note_management === 1 && (
                        <li>
                          <NavLink
                            to="/notes"
                            className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }
                          >
                            <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                            Note
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          </aside>

          <main
            className={
              sidebarActive ? "dashboard-main active" : "dashboard-main"
            }
          >
            {/* Header */}
            <div className="navbar-header">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-4">
                    <button
                      type="button"
                      className="sidebar-toggle"
                      onClick={sidebarControl}
                    >
                      {sidebarActive ? (
                        <Icon
                          icon="iconoir:arrow-right"
                          className="icon text-2xl non-active"
                        />
                      ) : (
                        <Icon
                          icon="heroicons:bars-3-solid"
                          className="icon text-2xl non-active"
                        />
                      )}
                    </button>
                    <button
                      onClick={mobileMenuControl}
                      type="button"
                      className="sidebar-mobile-toggle"
                    >
                      <Icon icon="heroicons:bars-3-solid" className="icon" />
                    </button>
                    {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
                  </div>
                </div>
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-3">
                    {location.pathname !== "/" && (
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => navigate(-1)}
                        title="Back"
                        style={{ padding: "0.35rem 0.6rem" }}
                      >
                        Back
                      </button>
                    )}
                    <ThemeToggleButton />
                    {/* Notification dropdown */}
                    {/* <div className="dropdown">
                      <button
                        className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <Icon
                          icon="iconoir:bell"
                          className="text-primary-light text-xl"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                         
                      </div>
                    </div> */}
                    {/* Profile dropdown */}
                    <div className="dropdown ">
                      <button
                        className="d-flex justify-content-center align-items-center rounded-circle bg-neutral-200 hover:scale-105 transition-transform p-6"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <FiUser
                          size={25}
                          className="w-12 h-12 object-fit-cover rounded-circle transition-all hover:bg-gray-100 ring-2 ring-gray-200/50"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-sm">
                        <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                          <div>
                            <h6 className="text-lg text-primary-light fw-semibold mb-2">
                              {user?.userFirstName} {user?.userLastName}
                            </h6>
                            <span className="text-secondary-light fw-medium text-sm">
                              {user?.department}
                            </span>
                          </div>
                        </div>
                        <ul className="to-top-list">
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              to={`/myProfile/${user?._id}`}
                            >
                              <Icon
                                icon="solar:user-linear"
                                className="icon text-xl"
                              />
                              My Profile
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                              to="/login"
                              onClick={handleLogout}
                            >
                              <Icon
                                icon="lucide:power"
                                className="icon text-xl"
                              />
                              Log Out
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="dashboard-main-body">{children}</div>

            {/* Footer */}
            <footer className="d-footer">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <p className="mb-0">
                    © 2025 DriftSurface Studio. All Rights Reserved.
                  </p>
                </div>
                <div className="col-auto">
                  <p className="mb-0">
                    Made by{" "}
                    <span className="text-primary-600">
                      VeravalOnline Pvt. Ltd.
                    </span>
                  </p>
                </div>
              </div>
            </footer>
          </main>
        </section>
      ) : (
        <section className={mobileMenu ? "overlay active" : "overlay"}>
          {/* Sidebar */}
          <aside
            className={
              sidebarActive
                ? "sidebar active"
                : mobileMenu
                  ? "sidebar sidebar-open"
                  : "sidebar"
            }
          >
            <button
              onClick={mobileMenuControl}
              type="button"
              className="sidebar-close-btn"
            >
              <Icon icon="radix-icons:cross-2" />
            </button>
            <div>
              <Link to="/" className="sidebar-logo">
                <img
                  src="/driftAssets/black_color_Logo.png"
                  alt="site logo"
                  className="light-logo"
                />
                <img
                  src="/driftAssets/black_color_Logo.png"
                  alt="site logo"
                  className="dark-logo"
                />
                <img
                  src="/driftAssets/black_color_Logo.png"
                  alt="site logo"
                  className="logo-icon"
                />
              </Link>
            </div>
            <div className="sidebar-menu-area">
              <ul className="sidebar-menu" id="sidebar-menu">
                {/* <li className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="solar:home-smile-angle-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/customer/dashboard"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                        Home
                      </NavLink>
                    </li>
                  </ul>
                </li> */}
                <li className="dropdown">
                  <Link to="#">
                    <AiOutlineProduct className="me-1" size={20} />
                    <span className="">My Orders</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/customer/myorder"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                        Order
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/customer/delevery_slip"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                        Delevery Slip
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <Link to="#">
                    <AiOutlineProduct className="me-1" size={20} />
                    <span className="">Orders</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/customer/addorder"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />
                        Add Order
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </aside>

          <main
            className={
              sidebarActive ? "dashboard-main active" : "dashboard-main"
            }
          >
            {/* Header */}
            <div className="navbar-header">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-4">
                    <button
                      type="button"
                      className="sidebar-toggle"
                      onClick={sidebarControl}
                    >
                      {sidebarActive ? (
                        <Icon
                          icon="iconoir:arrow-right"
                          className="icon text-2xl non-active"
                        />
                      ) : (
                        <Icon
                          icon="heroicons:bars-3-solid"
                          className="icon text-2xl non-active"
                        />
                      )}
                    </button>
                    <button
                      onClick={mobileMenuControl}
                      type="button"
                      className="sidebar-mobile-toggle"
                    >
                      <Icon icon="heroicons:bars-3-solid" className="icon" />
                    </button>
                    {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
                  </div>
                </div>
                <div className="col-auto">
                  <div className="d-flex flex-wrap align-items-center gap-3">
                    <ThemeToggleButton />
                    {/* Notification dropdown */}
                    {/* <div className="dropdown">
                      <button
                        className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <Icon
                          icon="iconoir:bell"
                          className="text-primary-light text-xl"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                        
                      </div>
                    </div> */}
                    {/* Profile dropdown */}
                    <div className="dropdown ">
                      <button
                        className="d-flex justify-content-center align-items-center rounded-circle bg-neutral-200 hover:scale-105 transition-transform p-6"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <FiUser
                          size={25}
                          className="w-12 h-12 object-fit-cover rounded-circle transition-all hover:bg-gray-100 ring-2 ring-gray-200/50"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-sm">
                        <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                          <div>
                            <h6 className="text-lg text-primary-light fw-semibold mb-2">
                              {user?.custName}
                            </h6>
                            {/* <span className="text-secondary-light fw-medium text-sm">
                          {user?.department}
                        </span> */}
                          </div>
                        </div>
                        <ul className="to-top-list">
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              to={`/customerProfile/${user?._id}`}
                            >
                              <Icon
                                icon="solar:user-linear"
                                className="icon text-xl"
                              />
                              My Profile
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                              to="/customer/login"
                              onClick={handleLogout}
                            >
                              <Icon
                                icon="lucide:power"
                                className="icon text-xl"
                              />
                              Log Out
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="dashboard-main-body">{children}</div>

            {/* Footer */}
            <footer className="d-footer">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <p className="mb-0">
                    © 2025 DriftSurface Studio. All Rights Reserved.
                  </p>
                </div>
                <div className="col-auto">
                  <p className="mb-0">
                    Made by{" "}
                    <span className="text-primary-600">
                      VeravalOnline Pvt. Ltd.
                    </span>
                  </p>
                </div>
              </div>
            </footer>
          </main>
        </section>
      )}
    </>
  );
};

export default DriftLayout;
